module.exports = __webpack_public_path__ + "static/media/05.18236a1b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Infographics/slides/05.jpg
// module id = 980
// module chunks = 0